import { Controller } from "@hotwired/stimulus"

export const NARROW_QUERY = "(max-width: 767px)"

// On a phone the first visit opens one day instead of a week. An explicit
// choice (?view= or the remembered cookie) is always kept.
export default class extends Controller {
  static values = {
    remembered: Boolean,
    narrowView: { type: String, default: "day" }
  }

  connect() {
    if (this.rememberedValue) return
    if (!window.matchMedia || !window.matchMedia(NARROW_QUERY).matches) return
    const url = new URL(window.location.href)
    if (url.searchParams.get("view")) return
    url.searchParams.set("view", this.narrowViewValue)
    if (window.Turbo) window.Turbo.visit(url.toString(), { action: "replace" })
    else window.location.replace(url.toString())
  }
}
